import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';

export default class PeekCarousel extends React.Component {
  constructor(props) {
    super(props);

    this.onResize = this.onResize.bind(this);
    this.onPrevious = this.onPrevious.bind(this);
    this.onNext = this.onNext.bind(this);
    this.onAfterSlide = this.onAfterSlide.bind(this);
    this.onBeforeSlide = this.onBeforeSlide.bind(this);
    this.lockSlide = false;
  }

  static propTypes = {
    items: PropTypes.arrayOf(PropTypes.object).isRequired,
    renderItem: PropTypes.func.isRequired,
    onResize: PropTypes.func.isRequired,
    itemsPerSlide: PropTypes.number,
    settings: PropTypes.object
  };

  static defaultProps = {
    itemsPerSlide: 3
  };

  componentDidMount() {
    this.onResize();
    window.addEventListener('resize', this.onResize); // re-render visible
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  onResize() {
    const carouselWidth = this.$carousel.clientWidth;
    const windowWidth = this.width = window.innerWidth;
    this.props.onResize(windowWidth, carouselWidth);
  }

  onPrevious() {
    if (this.lockSlide || !this.previousHandle) {
      return;
    }

    this.lockSlide = true;
    this.$slider.slickPrev();
  }

  onNext() {
    if (this.lockSlide || !this.nextHandle) {
      return;
    }
    this.lockSlide = true;
    this.$slider.slickNext();
  }

  onAfterSlide(currentSlide) {
    if (currentSlide > 0) {
      this.$previous.classList.add('arrow');
      this.previousHandle = true;
    }

    if ((currentSlide + this.props.itemsPerSlide) < this.props.items.length) {
      this.$next.classList.add('arrow');
      this.nextHandle = true;
    }

    this.lockSlide = false;
  }

  onBeforeSlide(current, next) {
    if (next <= 0) {
      this.$previous.classList.remove('arrow');
      this.previousHandle = false;
    }

    if ((next + this.props.itemsPerSlide) >= this.props.items.length) {
      this.$next.classList.remove('arrow');
      this.nextHandle = false;
    }
  }

  render() {
    const items = this.props.items;
    const itemsPerSlide = this.props.itemsPerSlide;

    const settings = Object.assign(this.props.settings || {}, {
      beforeChange: this.onBeforeSlide,
      afterChange: this.onAfterSlide
    });

    const itemViews = items.map(item => this.props.renderItem(item));

    const nextSlideClassName = `next${(itemsPerSlide < items.length) ? ' arrow' : ''}`;
    this.nextHandle = itemsPerSlide < items.length;

    return (
      <div className="peek-carousel-component" ref={carousel => this.$carousel = carousel}>
        <Slider {...settings} ref={slider => this.$slider = slider}>
          {itemViews}
        </Slider>
        <div className="previous" onClick={this.onPrevious} ref={div => this.$previous = div}>
          <div className="arrow-icon"/>
          <div className="cover"/>
        </div>
        <div className={nextSlideClassName} onClick={this.onNext} ref={div => this.$next = div}>
          <div className="arrow-icon"/>
          <div className="cover"/>
        </div>
      </div>);
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/PeekCarousel/index.jsx
 **/